import React, { useEffect } from 'react';
import { Location, useLocation, useParams } from 'react-router-dom';
import useStyles from 'isomorphic-style-loader/useStyles';

import { MaterialRenderer } from '../../components/MaterialRenderer/MaterialRenderer';
import { LandingPage } from '../../components/LandingPage/LandingPage';
import { SlActions } from '../../services/ActionsService/sl-actions';
import { SlDataService } from '../../services/sl-data.service';
import { RequestType, ActionType } from '../../global-interface';
import { SlLEContext } from '../../global-constants';
import { useContainerData } from '../../../../shared/public/SlHooks/useContainerData';

import s from './CourseContainer.scss';
import { Container, AuthService } from '../../../../symphony';
import { AINavbarService } from '../../../../navigation/private/services/ai-navbar.service';

export function CourseContainer(): JSX.Element {
  useStyles(s);
  const { courseAlias } = useParams();

  const { showNavbar } = Container.take('global', AINavbarService);

  const location: Location = useLocation();

  const { course$: course, loading$: loading } = useContainerData(
    SlLEContext,
    SlDataService,
    ['course$', 'loading$'],
  );

  useEffect(() => {
    showNavbar();
    const { actions$ } = Container.take(SlLEContext, SlActions);
    actions$.next({
      type: ActionType.OnCourseContainerMount,
      requestType: RequestType.Parallel,
      data: {
        alias: courseAlias,
        location,
      },
    });
  }, []);

  const authService = Container.take('global', AuthService);

  const renderComponent = () => {
    if (!authService.isLoggedIn()) {
      return <LandingPage alias={courseAlias} />;
    }
    return course && !loading?.courseSkeleton ? (
      <div className="le-course-container">
        <MaterialRenderer materialInfo={course.materialInfo} isExpanded>
          {course.children}
        </MaterialRenderer>
      </div>
    ) : null;
  };

  return renderComponent();
}
